<template>
  <generic-column-name-edition
    :value="generic_column_name"
    v-bind="$props"
    v-on="listeners_for_generic_column_name_edition"
    @input="validate_edition($event)"
  >
    <template #right_element="{in_edition}">
      <manual-column-name
        v-model="new_generic_column_name"
        :in_edition="in_edition"
      />
    </template>
  </generic-column-name-edition>
</template>

<script>
import _ from 'lodash'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import ManualColumnName from '@/components/manual_column_name.vue'
import {
  GenericColumnName,
  GenericColumnNameForRenaming,
} from '@/components/object_model.js'

export default {
  name: 'GenericColumnNameEditionForRenaming',
  components: {
    ManualColumnName,
    GenericColumnName,
    GenericColumnNameEdition,
  },
  props: [...GenericColumnNameEdition.props],
  data() {
    return {
      generic_column_name: undefined,
      new_generic_column_name: undefined,
    }
  },

  computed: {
    listeners_for_generic_column_name_edition() {
      return _.omit(this.$listeners, 'input')
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.generic_column_name = _.cloneDeep(nv.generic_column_name)
          this.new_generic_column_name = _.cloneDeep(nv.new_generic_column_name)
        }
      },
    },
  },

  methods: {
    validate_edition(generic_column_name) {
      let new_value = new GenericColumnNameForRenaming(
        generic_column_name.name,
        generic_column_name.contains_metavariables,
        this.new_generic_column_name
      )
      this.$emit('input', new_value)
    },
  },
}
</script>
